import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/homeData';

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Champions%20League%20football%20stadium%20with%20dramatic%20floodlights%20and%20players%20celebrating%20on%20the%20pitch%2C%20epic%20atmosphere%20with%20confetti%20and%20crowd%20cheering%2C%20professional%20sports%20photography%20with%20warm%20golden%20tones%2C%20cinematic%20composition&width=800&height=450&seq=home-news-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20intense%20moment%20two%20players%20facing%20off%20on%20the%20court%2C%20arena%20crowd%20energy%2C%20dramatic%20sports%20photography%20with%20motion%20and%20spotlights%2C%20warm%20orange%20and%20gold%20tones%2C%20professional%20sports%20photography&width=800&height=450&seq=home-news-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Chinese%20womens%20volleyball%20team%20celebrating%20victory%20on%20the%20court%2C%20dynamic%20action%20shot%20with%20athletes%20jumping%20and%20spiking%2C%20stadium%20atmosphere%20with%20red%20and%20gold%20colors%2C%20professional%20sports%20journalism%20photography&width=800&height=450&seq=home-news-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Formula%20One%20racing%20car%20speeding%20on%20track%20with%20motion%20blur%2C%20dramatic%20overcast%20sky%2C%20asphalt%20texture%20and%20speed%20sensation%2C%20professional%20motorsport%20photography%20with%20vibrant%20red%20and%20dark%20tones&width=800&height=450&seq=home-news-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20massive%20LED%20screens%20and%20packed%20audience%2C%20gaming%20competition%20stage%20with%20dramatic%20purple%20and%20cyan%20lighting%2C%20professional%20esports%20event%20photography%20with%20atmospheric%20haze&width=800&height=450&seq=home-news-05&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Professional%20swimmer%20in%20competition%20pool%20doing%20breaststroke%2C%20water%20splashes%20and%20intense%20motion%2C%20olympic%20stadium%20atmosphere%20with%20bright%20lighting%2C%20dynamic%20sports%20photography%20with%20crisp%20details&width=800&height=450&seq=home-news-06&orientation=landscape',
};

export default function NewsSection() {
  const categoryLabels: Record<string, string> = {
    football: '足球',
    basketball: '篮球',
    esports: '电竞',
    racing: '赛车',
    tennis: '网球',
    swimming: '游泳',
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-8 md:mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">体育资讯</h2>
              <p className="text-sm text-foreground-500 mt-1">最新最热的体育新闻，一手掌握</p>
            </div>
            <Link
              to="/category/football"
              className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
            >
              全部资讯 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {newsArticles.slice(0, 6).map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={articleImages[article.id]}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-medium px-2.5 py-1 rounded-full">
                    {categoryLabels[article.category] || article.category}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {article.summary}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span><i className="ri-time-line mr-1"></i>{article.date}</span>
                    <span><i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}